module.exports = require("packageurl-js");